import {Link} from "react-router-dom";
import React from "react";

export const StatusBoxes = ({item, index, number}) =>{

    return (
        <Link
            to={
                index === 0
                    ? '/tickets'
                    : index === 1
                        ? '/services'
                        : '/factors'
            }
            className={
                'card hoverable card-xl-stretch ' + `${item.bg}`
            }
            style={{
                backgroundImage:
                    'linear-gradient(to right, #00000036, #0000)'
            }}
        >
            <div className="card-body d-flex justify-content-between align-items-center">
                <div className={'d-flex flex-column align-items-start'}>
                    {item.svg}
                    <div className="text-white fw-bolder fs-4 mb-2 mt-5">
                        {item.title}
                    </div>
                </div>
                <div className="fw-bold text-white f-3">
                    {number[index]}
                </div>
            </div>
        </Link>
    );
}